import { render } from "./NFTsList.vue?vue&type=template&id=c9a5fb94"
import script from "./NFTsList.vue?vue&type=script&lang=js"
export * from "./NFTsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__